import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import logo from '../../assets/images/logo.png';
import Card from './components/Card';
import Header from './components/Header';
import services from '../../services/services';
import header from '../../assets/images/fejlec_hatter.jpg';
import { AppContext } from '../../context/appContext';
import { CompanyContext } from '../../context/companyContext';

const CompanyData = () => {
  // const [company, setCompany] = useState();
  const [cardContent, setCardContent] = useState();
  const [headerData, setHeaderData] = useState(null);
  const [sideImage, setSideImage] = useState(null);

  const [settings] = useContext(AppContext);
  const [company, setCompany] = useContext(CompanyContext);

  const getHeaderData = async () => {
    const response = await services.getHeaderData();

    if (response.data.status === 'OK') {
      const { imageUrl, backgroundColor } = response.data.data;

      const defaultHeader = settings?.headerBackgroundImage
        ? `/upload/${settings.headerBackgroundImage}`
        : header;
      const defaultColor =
        settings?.headerBackground || 'rgba(255, 236, 0, 0.82)';

      setHeaderData({
        imageUrl: imageUrl || defaultHeader,
        backgroundColor: backgroundColor || defaultColor
      });
    }
  };

  const getSideImage = async () => {
    const response = await services.getSideImage();

    const defaultSideImage = settings?.largeLogo || logo;

    if (response.data.status === 'OK') {
      setSideImage(response.data.data || defaultSideImage);
    }
  };

  const getCompanyData = async () => {
    const response = await services.getCompanyData();

    if (response.data.status === 'OK') {
      const { companyInfo, ...rest } = response.data.data;
      setCompany(rest);
      setCardContent(companyInfo);
    }
  };

  useEffect(() => {
    getHeaderData();
    getCompanyData();
    getSideImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);

  const generateHtml = () => ({ __html: company.description });
  return (
    <>
      <Header
        headerImage={headerData?.imageUrl}
        headerColor={headerData?.backgroundColor}
        img={company?.logoUrl}
        content={company?.contact}
      />
      <Root>
        <div
          className="content"
          dangerouslySetInnerHTML={company?.description && generateHtml()}
        />
        <img src={sideImage} alt="contactless_logo" />
      </Root>

      <CardRow>
        <Card content={cardContent?.left} icon={cardContent?.leftIcon} />
        <Card content={cardContent?.middle} icon={cardContent?.middleIcon} />
        <Card content={cardContent?.right} icon={cardContent?.rightIcon} />
      </CardRow>
    </>
  );
};

export default CompanyData;

const Root = styled.div`
  display: flex;
  padding: 2em 1em 1.5em 1em;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  @media (max-width: 960px) {
    flex-direction: column;
  }

  & > * {
    flex: 1;
    width: 50%;
    @media (max-width: 960px) {
      width: 90%;
    }
  }

  & img {
    width: 40%;
    flex-shrink: 2;
    height: auto;
    padding: 5%;
    @media (max-width: 960px) {
      width: 90%;
      max-width: 500px;
    }
  }

  & .content {
    padding: 2.5%;

    & h3 {
      font-size: 2.5em;
    }

    & p {
      line-height: 1.7em;
      letter-spacing: -0.7px;
      font-size: 15px;
    }
  }
`;

const CardRow = styled.div`
  max-width: 1400px;
  width: 90%;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;

  @media (max-width: 960px) {
    flex-direction: column;
    align-items: center;
  }
`;
